import React from 'react';

import { Button } from '@mui/material';

import useStyles from './styles';

interface Props {
    size?: 'small' | 'regular';
    fullWidth?: boolean;
    className?: string;
}

const BrowseApiButton: React.FC<Props> = ({ size = 'regular', fullWidth = false, className }) => {
    const { classes, cx } = useStyles();

    return (
        <Button
            disableElevation
            disableFocusRipple
            centerRipple
            variant="outlined"
            color="inherit"
            fullWidth={fullWidth}
            className={cx(
                classes.root,
                {
                    [classes._small]: size === 'small',
                    [classes._regular]: size === 'regular'
                },
                className
            )}
            href={'https://docs.vulners.com/docs/api/'}
            target="_blank"
            rel="noopener noreferrer"
        >
            {'Browse the API'}
        </Button>
    );
};

export default BrowseApiButton;
